const NUMBER_ADDRESS_ALLOWED_CHAR_PATTERN = /[0-9SsNn/-]/;

type NumberAddressMaskFactory = ((value?: string) => string) & {
  patterns: {
    Z: {
      pattern: RegExp;
    };
  };
};

export const NumberAddressMask: NumberAddressMaskFactory = Object.assign(() => 'Z*', {
  patterns: {
    Z: {
      pattern: NUMBER_ADDRESS_ALLOWED_CHAR_PATTERN,
    },
  },
});
